import { SortEnum } from "@finway-group/shared/lib/consts"
import { Vendor, VendorTypeEnum } from "@finway-group/shared/lib/models"

import { UserCreditor } from "../../utils/vendor.utils"

export type QueryParams = {
    page?: number
    limit?: number
    filter?: any
    search?: string
    sortOption?: SortEnum
    sortField?: string
}

export const defaultQueryParams = {
    page: 1,
    limit: 20,
    filter: "",
    search: "",
    sortOption: SortEnum.DESC,
    sortField: "createdAt",
}

export const defaultDropdownQueryParams = {
    limit: 10,
    sortOption: SortEnum.DESC,
    sortField: "createdAt",
}

export type VendorDropdown = Pick<Vendor, "name" | "isApproved" | "creditorNumber" | "img" | "deleted" | "dateDeleted"> & { type: VendorTypeEnum.VENDOR; id: string }
export type UserCreditorDropDown = Pick<UserCreditor, "name" | "creditorNumber" | "img" | "deleted" | "dateDeleted"> & {
    type: VendorTypeEnum.USER
    id: string
}

export type CreditorDropdown = VendorDropdown | UserCreditorDropDown
